import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SimpleNavbar } from '../../components/layout/SimpleNavbar';
import { AuthButton } from '../../components/common/AuthButton';
import { FormInput } from '../../components/common/FormInput';
import { SimpleDropdown } from '../../components/common/SimpleDropdown';

export const RegisterScoutPage = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    jobTitle: '',
    teamName: '',
    state: 'Alabama',
    agreeToTerms: false
  });

  const states = [
    { value: 'Alabama', label: 'Alabama' },
    { value: 'Alaska', label: 'Alaska' },
    { value: 'Arizona', label: 'Arizona' },
    { value: 'Arkansas', label: 'Arkansas' },
    { value: 'California', label: 'California' },
    { value: 'Colorado', label: 'Colorado' },
    { value: 'Connecticut', label: 'Connecticut' },
    { value: 'Delaware', label: 'Delaware' },
    { value: 'Florida', label: 'Florida' },
    { value: 'Georgia', label: 'Georgia' },
    { value: 'Hawaii', label: 'Hawaii' },
    { value: 'Idaho', label: 'Idaho' },
    { value: 'Illinois', label: 'Illinois' },
    { value: 'Indiana', label: 'Indiana' },
    { value: 'Iowa', label: 'Iowa' },
    { value: 'Kansas', label: 'Kansas' },
    { value: 'Kentucky', label: 'Kentucky' },
    { value: 'Louisiana', label: 'Louisiana' },
    { value: 'Maine', label: 'Maine' },
    { value: 'Maryland', label: 'Maryland' },
    { value: 'Massachusetts', label: 'Massachusetts' },
    { value: 'Michigan', label: 'Michigan' },
    { value: 'Minnesota', label: 'Minnesota' },
    { value: 'Mississippi', label: 'Mississippi' },
    { value: 'Missouri', label: 'Missouri' },
    { value: 'Montana', label: 'Montana' },
    { value: 'Nebraska', label: 'Nebraska' },
    { value: 'Nevada', label: 'Nevada' },
    { value: 'New Hampshire', label: 'New Hampshire' },
    { value: 'New Jersey', label: 'New Jersey' },
    { value: 'New Mexico', label: 'New Mexico' },
    { value: 'New York', label: 'New York' },
    { value: 'North Carolina', label: 'North Carolina' },
    { value: 'North Dakota', label: 'North Dakota' },
    { value: 'Ohio', label: 'Ohio' },
    { value: 'Oklahoma', label: 'Oklahoma' },
    { value: 'Oregon', label: 'Oregon' },
    { value: 'Pennsylvania', label: 'Pennsylvania' },
    { value: 'Rhode Island', label: 'Rhode Island' },
    { value: 'South Carolina', label: 'South Carolina' },
    { value: 'South Dakota', label: 'South Dakota' },
    { value: 'Tennessee', label: 'Tennessee' },
    { value: 'Texas', label: 'Texas' },
    { value: 'Utah', label: 'Utah' },
    { value: 'Vermont', label: 'Vermont' },
    { value: 'Virginia', label: 'Virginia' },
    { value: 'Washington', label: 'Washington' },
    { value: 'West Virginia', label: 'West Virginia' },
    { value: 'Wisconsin', label: 'Wisconsin' },
    { value: 'Wyoming', label: 'Wyoming' },
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleDropdownChange = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate passwords match
    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match');
      return;
    }

    // Validate team name is provided
    if (!formData.teamName.trim()) {
      alert('Please enter an organization / team name');
      return;
    }

    // Navigate to plans selection with registration data
    navigate('/auth/plans-selection', {
      state: {
        registrationData: {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          password: formData.password,
          jobTitle: formData.jobTitle,
          teamName: formData.teamName,
          state: formData.state,
        },
        role: 'scout',
      },
    });
  };

  return (
    <div className="min-h-screen bg-common-gradient">
      <SimpleNavbar />

      <div className="flex items-center justify-center min-h-screen px-4 pt-24 pb-16">
        <div className="max-w-2xl w-full">

          <div className="text-center mb-12">
            <p className="text-sm text-gray-400 font-roboto mb-2">STEP 1</p>
            <h1 className="text-5xl font-anton text-white">
              REGISTRATION FOR SCOUT
            </h1>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">

            {/* First Name */}
            <FormInput
              label="First name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              required
            />

            {/* Last Name */}
            <FormInput
              label="Last name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              required
            />

            {/* Work Email */}
            <FormInput
              label="Work email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            {/* Password */}
            <FormInput
              label="Password"
              name="password"
              type="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Password (8 or more characters)"
              required
            />

            {/* Confirm Password */}
            <FormInput
              label="Confirm password"
              name="confirmPassword"
              type="password"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Password (8 or more characters)"
              required
            />

            {/* Organization / Team Name */}
            <FormInput
              label="Organization / Team Name"
              name="teamName"
              value={formData.teamName}
              onChange={handleChange}
              placeholder="Enter organization or team name"
              required
            />

            {/* Job Title */}
            <FormInput
              label="Job Title"
              name="jobTitle"
              value={formData.jobTitle}
              onChange={handleChange}
              required
            />

            {/* State */}
            <div>
              <label className="block text-left text-white text-sm mb-3 font-roboto">
                State
              </label>
              <SimpleDropdown
                value={formData.state}
                onChange={(value) => handleDropdownChange('state', value)}
                options={states}
                placeholder="Select State"
                variant="form"
              />
            </div>

            {/* Terms Checkbox */}
            <div className="flex items-start space-x-3 pt-2">
              <input
                type="checkbox"
                name="agreeToTerms"
                checked={formData.agreeToTerms}
                onChange={handleChange}
                required
                className="mt-1 w-5 h-5 rounded border-slate-600 bg-slate-800/50 text-cyan-400 focus:ring-2 focus:ring-cyan-400/50"
              />
              <label className="text-white text-sm font-roboto">
                Agree to Terms of Service
              </label>
            </div>

            {/* Submit Button */}
            <div className="pt-6 flex justify-center">
              <AuthButton type="submit">
                NEXT
              </AuthButton>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterScoutPage;
